import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=73e800d7&scoped=true"
import script from "./Deal.vue?vue&type=script&lang=js"
export * from "./Deal.vue?vue&type=script&lang=js"
import style0 from "./Deal.vue?vue&type=style&index=0&id=73e800d7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e800d7",
  null
  
)

export default component.exports